<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Products',

    metaInfo() {
      return {
        title: this.$t('products.title'),
      }
    },

    extends: View,

    mixins: [
      LoadSections([
        'hero-alt',
        // 'background-info',
        'products-gallery',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'products',
      },
    },
  }
</script>
